// @ts-check
import { z } from 'zod';

import Timestamp from '../../models/global/Timestamp';

export const EnvelopeFields = z.array(z.object({
    party_id: z.number(),
    party_title: z.string(),
    documents: z.array(z.object({
      document_id: z.number(),
      document_title: z.string(),
      fields: z.array(z.object({
        merge_field: z.string(),
        input_id: z.number(),
        value: z.string().nullable(),
      })),
    })),
}));

export const EnvelopeFieldsUpdate = z.object({
  data: z.array(z.object({
    input_id: z.number(),
    value: z.string().nullable(),
  })),
  envelope_progressed_at: Timestamp,
});

/** @typedef {z.infer<typeof EnvelopeFields>} TEnvelopeFields */
/** @typedef {z.infer<typeof EnvelopeFieldsUpdate>} TEnvelopeFieldsUpdate */
